export const SUPPORTED_LANGUAGES = [
  'en',
  'da',
  'sv',
  'de',
  'fr',
  'es',
  'nl',
  'pl',
  'fi',
  'ro'
] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const SCREENING_OUTCOME = ['pass', 'fail'] as const;
export type ScreeningOutcome = (typeof SCREENING_OUTCOME)[number];
